import React, {useState} from 'react'
import PropTypes from 'prop-types'
import SelectInput from '../../SelectInput'
import DateInput from '../../DateInput'
import {OpenHourOptions} from './chatSettingConstants'
import TextInput from '../../TextInput'

const CLOSED_ENUM = 'CLOSED_ENUM'
const startTimeOptions = [{value: CLOSED_ENUM, label: 'Closed'}, ...OpenHourOptions]

function SingleDeskHourExceptionInput(props) {
  const [closeTimeOptions, setCloseTimeOptions] = useState(
    props.value.openTime
      ? OpenHourOptions.filter(t => {
          return parseInt(t.value) > props.value.openTime
        })
      : OpenHourOptions,
  )
  const [inValidFields, setInvalidFields] = useState(['date', 'openTime', 'closeTime'])

  const handleDayChange = day => {
    let newObj = {...props.value, date: day.toISOString().split('T')[0]} // store only YYYY-MM-DD
    props.onChange(newObj)
    setInvalidFields([...inValidFields].filter(e => e !== 'dayOfWeek'))
  }

  const handleStartTimeChange = openTime => {
    // handle closed all day case
    if (openTime === CLOSED_ENUM) {
      props.onChange({...props.value, isClosedAllDay: true, openTime: 0, closeTime: 0})
    } else {
      // not closed all day, set isClosedAllDay to false
      props.onChange({...props.value, openTime: parseInt(openTime), isClosedAllDay: false})
      setCloseTimeOptions(
        OpenHourOptions.filter(t => {
          return parseInt(t.value) > parseInt(openTime)
        }),
      )
    }
    setInvalidFields([...inValidFields].filter(e => e !== 'openTime'))
  }

  const handleCloseTimeChange = time => {
    props.onChange({...props.value, closeTime: parseInt(time)})
    setInvalidFields([...inValidFields].filter(e => e !== 'closeTime'))
  }

  return (
    <React.Fragment>
      <DateInput
        onChange={handleDayChange}
        label={'Date'}
        isRequired={true}
        value={props.value.date ? new Date(props.value.date + 'T12:00:00.000Z') : null} // this avoids any timezone issues
        error={props.error && inValidFields.includes('dayOfWeek')}
      />
      <SelectInput
        onChange={handleStartTimeChange}
        label={'Hours open start'}
        isRequired={true}
        options={startTimeOptions}
        value={props.value.isClosedAllDay ? CLOSED_ENUM : '' + (typeof props.value.openTime === 'number' ? props.value.openTime : '')}
        error={props.error && inValidFields.includes('openTime')}
      />
      {props.value.isClosedAllDay ? (
        <TextInput label={'Hours open end'} isRequired={true} value={'Closed'} isDisabled={true} />
      ) : (
        <SelectInput
          onChange={handleCloseTimeChange}
          label={'Hours open end'}
          isRequired={true}
          options={closeTimeOptions}
          value={'' + (typeof props.value.closeTime === 'number' ? props.value.closeTime : '')}
          disabled={typeof props.value.openTime !== 'number' && !props.value.isClosedAllDay}
          error={props.error && inValidFields.includes('closeTime')}
        />
      )}
    </React.Fragment>
  )
}

SingleDeskHourExceptionInput.propTypes = {
  value: PropTypes.shape({
    date: PropTypes.string, // YYYY-MM-DD format
    openTime: PropTypes.number, // in minutes since midnight
    closeTime: PropTypes.number, // in minutes since midnight
    isClosedAllDay: PropTypes.bool, // true if desk is closed on this date, ignore openTime and closeTime
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
}

export default SingleDeskHourExceptionInput
